import { Decorations } from "../decorations";
import { RicosNodeStyle } from "../document-style/node-style";
import { RicosTextStyle } from "../document-style/text-style";
import { TextStyleTransformer } from "../text-style-transformer";
import themeStrategy from "../themeStrategy/themeStrategy";
class RicosTextualTheme {
  constructor(theme) {
    this.theme = theme;
    this.documentStyle = TextStyleTransformer.fromTheme(this.theme).toDocumentStyle();
  }
  /**
   * Extracts given decoration settings for specific node type from the current theme.
   */
  getDecoration(nodeType, decorationType) {
    const textNodeStyle = this.documentStyle[nodeType];
    return Decorations.of(textNodeStyle?.decorations || []).byType(decorationType);
  }
  getTextStyle(nodeType) {
    return RicosTextStyle.of({ lineHeight: this.documentStyle[nodeType]?.lineHeight });
  }
  getNodeStyle(nodeType) {
    return RicosNodeStyle.of(this.documentStyle[nodeType]?.nodeStyle);
  }
  /**
   * Translates RicosTheme to HTML style tag with CSS variable definitions
   */
  toStyleTag() {
    return themeStrategy({ ricosTheme: this.theme }).html;
  }
  /**
   * Returns palette colors for the current theme
   */
  getColors() {
    return themeStrategy({ ricosTheme: this.theme }).themeData.colors || {};
  }
}
export {
  RicosTextualTheme as default
};
//# sourceMappingURL=textual-theme.js.map
